import MinhaContaAPI from '@/api/minhaconta'
import EmpresaAPI from '@/api/empresa'

export default {
  async init({ commit }) {
    try {
      commit('SET_LOADING', true)
      const [resInteresses, resAnexos, resEmpresas] = await Promise.all([
        MinhaContaAPI.listInteresse(),
        MinhaContaAPI.listAnexo(),
        MinhaContaAPI.listEmpresa(),
      ])
      const interesses = resInteresses.data.content
      const anexos = resAnexos.data.content
      const empresas = resEmpresas.data.content
      commit('SET_INTERESSES', interesses)
      commit('SET_ANEXOS', anexos)
      commit('SET_EMPRESAS', empresas)
      const paramsUnidade = new URLSearchParams()
      interesses.map(e => paramsUnidade.append('id', e.unidadeId))
      const resUnidades = await EmpresaAPI.listUnidade(paramsUnidade)
      commit('SET_UNIDADES', resUnidades.data.content)
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async fetchAnexos({ commit }) {
    try {
      commit('SET_LOADING', true)
      const anexos = await MinhaContaAPI.listAnexo()
      commit('SET_ANEXOS', anexos.data.content)
    } finally {
      commit('SET_LOADING', false)
    }
  },
}
